module.exports = __webpack_public_path__ + "img/Dschungel.ee72b256.jpg";